import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleCalendarRegular from './google-calendar-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleCalendarRegular {...validProps} />;
}
SvgComponent.iconName = 'googleCalendarRegular';

export const GoogleCalendarRegularIcon = svgIconWrapper(SvgComponent);
